import React from 'react';
import Favourites from './Favourites';
import MenuSectionContent from './MenuSectionContent';

const MenuSection = ({ menuSection, activeFilters }) => {
    if (!menuSection) return null;

    return (
        <div className="m__menus-content-section" data-section-id={menuSection.id}>
            <h2 className="text-black text-[32px] xl:text-[75px] font-extrabold font-title uppercase leading-[40px] xl:leading-[65px] mb-3 xl:mb-4">
                {menuSection.display_name || menuSection.title}
            </h2>
            
            <Favourites menuItems={menuSection.favourites} activeFilters={activeFilters} />
            <MenuSectionContent content={menuSection.menu_content} activeFilters={activeFilters} />
        </div>
    );
};

export default MenuSection;